import { Box, ModalDialog } from '@mui/joy';
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import Typography from '@mui/joy/Typography';
import type { Dispatch, SetStateAction } from 'react';

type BasicModalProps = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title?: string;
  children?: React.ReactNode;
  startIcon?: React.ReactNode;
  width?: string;
};
/** @deprecated use the new modal component */
export const BasicModal = ({
  open,
  setOpen,
  title,
  children,
  startIcon,
  width
}: BasicModalProps) => {
  return (
    <Modal
      aria-describedby="modal-desc"
      aria-labelledby="modal-title"
      onClose={() => setOpen(false)}
      open={open}
      // hideBackdrop
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'none',
        zIndex: 10_001
      }}
    >
      <ModalDialog sx={{ width }}>
        <ModalClose sx={{ m: 1 }} variant="plain" />
        <Typography
          component="h2"
          fontWeight="lg"
          id="modal-title"
          level="h4"
          mb={1}
          textColor="inherit"
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}
          >
            {startIcon} {title}
          </Box>
        </Typography>
        {children}
      </ModalDialog>
    </Modal>
  );
};
